// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2GnFK","cell":"ColumnAccessor_cell__35lVm","firstCellAccent":"ColumnAccessor_firstCellAccent__1Vg8Z"};